import whowe from '../../assets/About/AboutImage.svg'

export default function Whowe() {
    return (
        <section className="py-8 md:py-12 bg-[#F4F5F6] px-8 sm:px-6 lg:px-24 ">
            <div className="mx-auto max-w-7xl">

                <p className="text-sm sm:text-base text-secondary-500">
                    Who we are
                </p>

                <h2 className="font-semibold text-black tracking-[0.7px] py-6 sm:py-8 text-2xl sm:text-3xl lg:text-4xl">
                    We are SAN Technovation
                </h2>

                <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-14">

                    {/* TEXT CONTENT */}
                    <div className="w-full md:max-w-[580px]">

                        <p className="font-secondary text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed">
                            We build intelligent digital systems that help businesses operate better,
                            scale faster, and stay future-ready.
                        </p>

                        <p className="font-secondary font-medium text-lg sm:text-xl pt-4 sm:pt-5">
                            Part of SAN Group
                        </p>

                        <p className="text-gray-600 text-sm sm:text-base lg:text-[18px] py-3 sm:py-4 leading-relaxed">
                            SAN Technovation is part of the SAN Group — a growing multi-vertical
                            organization built across technology, engineering, design, infrastructure,
                            and sustainable solutions.
                        </p>

                        <p className="text-gray-600 text-sm sm:text-base lg:text-[18px] py-3 sm:py-4 leading-relaxed">
                            The group operates through focused business units including digital systems,
                            engineering services, creative design, renewable energy, and planning
                            solutions — all driven by innovation, quality, and long-term value creation.
                        </p>

                        <p className="text-gray-600 text-sm sm:text-base lg:text-[18px] py-3 sm:py-4 leading-relaxed">
                            Together, the SAN Group works toward building practical solutions that
                            support businesses, communities, and future development.
                        </p>

                    </div>

                    {/* IMAGE */}
                    <div className="w-full  lg:w-1/2 flex justify-center lg:justify-end">
                        <img
                            src={whowe}
                            alt="Who we are"
                            className="w-full max-w-sm sm:max-w-md lg:max-w-full rounded-lg"
                        />
                    </div>

                </div>
            </div>
        </section>
    )
}


